<template>
  <div>
    <Head title="Create Booking" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/bookings">Biglietti</Link>
      <span class="text-indigo-400 font-medium">/</span> Crea
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.adults_qty" :error="form.errors.adults_qty" class="pb-8 pr-6 w-full lg:w-1/2" label="Adulti (quantità)" />
          <text-input v-model="form.kids_qty" :error="form.errors.kids_qty" class="pb-8 pr-6 w-full lg:w-1/2" label="Bambini (quantità)" />
          <text-input v-model="form.date" :error="form.errors.date" class="pb-8 pr-6 w-full lg:w-1/2" label="Data" />
          <text-input v-model="form.total" :error="form.errors.total" class="pb-8 pr-6 w-full lg:w-1/2" label="Totale pagato" />
          <select-input v-model="form.paid" :error="form.errors.paid" class="pb-8 pr-6 w-full lg:w-1/2" label="Pagato">
            <option :value="true">Si</option>
            <option :value="false">No</option>
          </select-input>
          <select-input v-model="form.payment_type" :error="form.errors.payment_type" class="pb-8 pr-6 w-full lg:w-1/2" label="Tipo pagamento">
            <option :value="true">Cash</option>
            <option :value="false">Online</option>
          </select-input>
          <select-input v-model="form.stations" :error="form.errors.stations" class="pb-8 pr-6 w-full lg:w-1/2" label="Ombrelloni">
            <option :value="true">1</option>
            <option :value="false">2</option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">Crea nuovo</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DashboardLayout from "@/Pages/Dashboard/Shared/DashboardLayout";
import FileInput from "@/Pages/Dashboard/Shared/FileInput";
import LoadingButton from "@/Pages/Dashboard/Shared/LoadingButton";
import SelectInput from "@/Pages/Dashboard/Shared/SelectInput";
import TextInput from "@/Pages/Dashboard/Shared/TextInput";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: DashboardLayout,
  remember: "form",
  data() {
    return {
      form: this.$inertia.form({
        name: "",
        email: "",
        adults_qty: "",
        kids_qty: "",
        date: "",
        total: "",
        paid: "",
        payment_type: "",
        stations: "",
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/bookings");
    },
  },
};
</script>
